import fetch from 'api/fetch'

/**
 * 根据spuId获取详情信息
 * @param {Object} params - 包含spuId属性.
 */
export function getSpuInfoApi(spuId, operateType, channel) {
  let url = '/product/getInfo.json'
  if (operateType == 2) {
    // 拼团使用特定的接口
    url = '/groupon/getInfo'
  }
  return fetch({
    url,
    params: {
      spuId,
      channel
    }
  })
}

/**
 * 根据spuId获取详情信息
 * @param {Number} typeId - 商品类型
 */
export function getSkuInfoApi({ spuId, skuId, typeId, operateType, channel }) {
  let url = '/product/getDetail.json'
  if (operateType == 2) {
    // 拼团使用特定的接口
    url = '/groupon/getDetail'
  }
  return fetch({
    url,
    params: {
      spuId,
      skuId,
      typeId,
      channel
    }
  })
}

/**
 * 正常购买之前的校验
 * @param {*} params
 */
export function isAllowedSellApi(params) {
  return fetch({
    url: '/buy/isAllowedSell',
    params
  })
}

/**
 * 拼团之前的校验
 * @param {String} promotionId 拼团活动Id
 * @param {String} grouponId 团Id
 */
export function isGroupAllowedApi({ skuId, promotionId, grouponId, channel, num, suiteCode }) {
  return fetch({
    url: '/groupon/isGrouponActAllowSell',
    params: {
      skuId,
      promotionId,
      grouponId,
      num,
      suiteCode,
      channel
    }
  })
}

/**
 * 根据skuId、money获取分期信息
 * @param {Object} params - 包含skuId属性,money属性.
 */
export function getInstallmentApi({ skuId, money }) {
  return fetch({
    url: '/product/getInstallmentDetail',
    params: {
      skuId,
      money
    }
  })
}
